import type { ResReadPointAssetInfoType } from '@/types';

type InfoTabType = {
  info: ResReadPointAssetInfoType[];
  setTab: (value: any) => void;
  tab: number;
};
export default function InfoTab(infos: InfoTabType) {
  const { info, tab, setTab } = infos;
  const lenth = info.length;

  return (
    <div className="mx-auto flex justify-center gap-[1px] px-[17px] font-[800]">
      {Number(lenth) >= 1 && (
        <button
          onClick={() => setTab(1)}
          style={{
            textShadow: tab === 1 ? '0px 2px 0px 0px #FF9473' : 'none',
          }}
          className={`w-full rounded-tl-3xl py-[10px] text-[12px] ${Number(lenth) === 1 && 'rounded-tr-3xl'} ${tab === 1 ? 'bg-[#FF6535] text-[#FFF26C]' : 'bg-[#B2B2B2] text-[#DBDBDB]'}`}
        >
          POOL 1
        </button>
      )}
      {Number(lenth) >= 2 && (
        <button
          onClick={() => setTab(2)}
          style={{
            textShadow: tab === 2 ? '0px 2px 0px 0px #FF9473' : 'none',
          }}
          className={`w-full rounded py-[10px] text-[12px] ${Number(lenth) === 2 && 'rounded-tr-3xl'} ${tab === 2 ? 'bg-[#FF6535] text-[#FFF26C]' : 'bg-[#B2B2B2] text-[#DBDBDB]'}`}
        >
          POOL 2
        </button>
      )}

      {Number(lenth) >= 3 && (
        <button
          onClick={() => setTab(3)}
          style={{
            textShadow: tab === 3 ? '0px 2px 0px 0px #FF9473' : 'none',
          }}
          className={`w-full rounded rounded-tr-3xl py-[10px] text-[12px] ${Number(lenth) === 3 && 'rounded-tr-3xl'} ${tab === 3 ? 'bg-[#FF6535] text-[#FFF26C]' : 'bg-[#B2B2B2] text-[#DBDBDB]'}`}
        >
          POOL 3
        </button>
      )}
    </div>
  );
}
